import { ApolloClient, ApolloLink, InMemoryCache, createHttpLink } from '@apollo/client';
import { clearUserCredentials, getUserId } from './auth';

import { onError } from '@apollo/client/link/error';

const httpLink = createHttpLink({
  uri: '/graphql',
  credentials: 'include',
});

const errorLink = onError(({ graphQLErrors, operation }) => {
  // This is a workaround, since we can't access CurrentUserContext here
  const isAuthenticated = getUserId();

  if (graphQLErrors) {
    graphQLErrors.map(({ path, extensions }) => {
      if (extensions) {
        switch (extensions['code']) {
          case 'AUTHENTICATION_ERROR':
            if (path[0] !== 'currentUserProfile' && isAuthenticated) {
              clearUserCredentials();
              operation.getContext().client.clearStore();
              window.alert('Your session has EXPIRED! You will be redirected to login.');
              window.location.href = window.location.origin;
            }
            break;
        }
      }
    });
  }
});

const createCache = () => {
  const cache = new InMemoryCache();

  if (process.env.NODE_ENV === 'development') {
    window.cacheContainer = cache;
  }

  return cache;
};

export const createClient = () => {
  const client = new ApolloClient({
    link: ApolloLink.from([
      new ApolloLink((operation, forward) => {
        // Attach the client instance to context
        operation.setContext({ client });
        return forward(operation);
      }),
      errorLink,
      httpLink,
    ]),
    credentials: 'include', // Ensures cookies are sent
    cache: createCache(),
    addTypename: false,
  });

  return client;
};
